import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BaseApiTemplateService} from '../shared/base-api-template-service.model';
import {Core2Config} from '../shared/core2Config';
import {LinkSubjectToCashbookContainerModel} from '../../../../../models/aggregates/cashbook/link-subject-to-cashbook-container.model';


@Injectable({
  providedIn: 'root'
})
export class LinkSubjectToCashbookService extends BaseApiTemplateService<LinkSubjectToCashbookContainerModel> {

  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + 'erp/cashbook-login-subject-links';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + 'erp/cashbook-login-subject-links';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + 'erp/cashbook-login-subject-links';
    this.httpClient = http;
  }
}
